import React from 'react';
import 'whatwg-fetch'
import PropTypes from 'prop-types';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import styles from '../css/app.css';
import { getSafeImageUrl } from '../utils';

const fetcher = url => fetch(url).then(r => r.json())

class ImageElement extends React.Component {
  constructor(props) {
    super(props);
    this.onLoad = this.onLoad.bind(this);
  }

  onLoad(image) {
    var imgEl = image.target;
    if (imgEl.naturalHeight > imgEl.naturalWidth) {
      imgEl.classList.add(styles.portraitImage);
    }
  }
  render () {
    var {loading, imageSrc, imageAlt, scrollPosition} = this.props;

    if (loading) {
      return (
        <div className={styles.skeleton} />
      );
    }

    if (imageSrc === null) {
      return null;
    }

    return (
      <LazyLoadImage
        src={getSafeImageUrl(imageSrc)}
        alt={imageAlt}
        effect="opacity"
        className={styles.image}
        ref={this.setRef}
        onLoad={this.onLoad}
        onError={this.props.onError}
        scrollPosition={scrollPosition}
      />
    );
  }
}

class GridItem extends React.Component {

  constructor(props) {
    super(props);
    this.onError = this.onError.bind(this);
    this.state = {
      errored: false,
      imageSrc: this.props.imageSrc,
    }
  }

  async onError() {
    this.setState({
      errored: true,
    })
    const result = await fetcher(`/${window.location.pathname.slice(1)}/refresh_update?update_id=${this.props.serviceUpdateId}`)
    this.setState({
      imageSrc: result.update ? result.update.thumbnail : null,
      errored: false,
    })
  }

  render() {
    const {
      imageAlt,
      imageUrl,
      scrollPosition,
      serviceUpdateId,
    } = this.props

    if (this.state.imageSrc === null) {
      return null
    }

    return (
      <div className={styles.image_container}>
        {imageUrl && imageUrl.length > 0
        && (
          <a href={imageUrl} className={styles.overlay}>
            <div className={styles.overlay_button}>
              <span className={styles.button}>View</span>
            </div>
            <ImageElement
              onError={this.onError}
              loading={this.state.errored}
              imageSrc={this.state.imageSrc}
              imageAlt={imageAlt}
              serviceUpdateId={serviceUpdateId}
            />
          </a>
        )
        }
        {(!imageUrl || imageUrl.length === 0)
        && (
          <ImageElement
            onError={this.onError}
            loading={this.state.errored}
            scrollPosition={scrollPosition}
            imageSrc={this.state.imageSrc}
            imageAlt={imageAlt}
          />
        )
        }
      </div>
    )
  }
}

GridItem.propTypes = {
  imageSrc: PropTypes.string.isRequired,
  imageAlt: PropTypes.string,
  imageUrl: PropTypes.string,
};

GridItem.defaultProps = {
  imageAlt: '',
  imageUrl: '',
};

export default GridItem;



/** WEBPACK FOOTER **
 ** ./app/webroot/js/instagramBioGrid/components/GridItem.jsx
 **/